import { render, staticRenderFns } from "./employeeInductionTask.vue?vue&type=template&id=4efee3f2&scoped=true"
import script from "./employeeInductionTask.vue?vue&type=script&lang=js"
export * from "./employeeInductionTask.vue?vue&type=script&lang=js"
import style0 from "./employeeInductionTask.vue?vue&type=style&index=0&id=4efee3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efee3f2",
  null
  
)

export default component.exports